import { useHistory, useLocation } from 'react-router-dom';
import Footer from '../components/layout/Footer';
import Header from '../components/layout/Header';

import '../scss/landingPage.scss'

type LandingLayoutProps = {
    children: React.ReactNode
}

const LandingLayout = ({ children }: LandingLayoutProps) => {

    const history = useHistory();
    const { pathname } = useLocation();

    const moverseA = (id: string): void => {
        window.location.hash = ""
        if (pathname === '/') {
            window.location.hash = "#" + id;
        } else {
            history.push(`/#${id}`);
        }
    }
    return (
        <div className="main_LandingPage">
            <Header moverseA={moverseA} />
            {children}
            <Footer moverseA={moverseA} />
        </div>
    );
}

export default LandingLayout;